import React, { useEffect } from "react";
import "./Blogs.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import Blog_Card from "./blog_card/Blog_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllBlog } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Blogs = () => {
  const data = [
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Open Monitoring Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
    {
      blog_title: "Movement Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
  ];

  const dispatch = useDispatch();
  const all_blogs = useSelector((state) => state.common.all_blogs);


  useEffect(() => {
    dispatch(AllBlog());
  }, [dispatch])

  return (
    <section className="Blogs">
      <div className="container">
        <Common_Title_3 titleText="Blogs" seelink={'/all-meditations'} />

        <div className="blogs_card_holder">
          <div className="row">
            {all_blogs?.map((item) => {
              return (
                <div className="col-lg-3 col-md-4 col-6 mb-4  ">
                  <Blog_Card
                    img={IDS.IMG_URL + item?.Blog?.image}
                    blogTitle={item?.name}
                    link={`/meditation-blog-details/${item?.Blog?.id}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
